// ASI validates file support during upload instead of restricting local file selection.
export const ASI_FILE_UPLOAD_ACCEPTED_FILE_TYPES = '*';
export const ASI_FILE_UPLOAD_MAX_FILE_SIZE_MB = 200;
/**
 * Transport settings every surface must send when uploading on the agent's
 * behalf. `skipParsing` keeps binary/unsupported files as raw S3 URLs (all
 * the agent needs) and `defaultFileSource` preserves original raster files
 * through upload. SVG sanitization still runs on the server.
 * They are one contract: diverging values would make the same file upload
 * with different semantics across products.
 */
export const ASI_FILE_UPLOAD_TRANSPORT = {
    defaultFileSource: 'asi',
    skipParsing: true,
};
//# sourceMappingURL=asiFileUploadConfig.js.map